import {CatalogPageProvider} from 'modules/products/providers/CatalogPageProvider';
import {NextPage} from 'next';
import {withBasicDataServerSide} from 'core/next/controllers';
import {catalogController} from 'modules/products/controller';
import {CatalogPageContent} from 'modules/products/pages/CatalogPage';
import {TGetListingTransformedResponse} from 'plugins/modules/listing/types';
import {IProductShort} from 'modules/products/types';
import {TGetListingRequest} from 'plugins/modules/listing/api/api';
import {IBreadcrumb} from 'modules/seo/types';

interface IListingPageProps {
    data: TGetListingTransformedResponse<IProductShort>;
    initialArgs: TGetListingRequest<{section: string}>;
    breadcrumbs: IBreadcrumb[];
}

const CatalogPage: NextPage<{
    pageProps: IListingPageProps;
}> = ({pageProps}) => {
    return (
        <CatalogPageProvider
            key={pageProps.initialArgs.section}
            initialData={pageProps.data}
            initialArgs={pageProps?.initialArgs}
        >
            <CatalogPageContent breadcrumbs={pageProps.breadcrumbs} />
        </CatalogPageProvider>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    const {data, initialArgs, breadcrumbs} = await catalogController(store, ctx);

    return {
        props: {
            data,
            initialArgs,
            breadcrumbs,
        },
    };
});

export default CatalogPage;
